import React, { Component } from 'react';
import $, { param } from 'jquery';
import ReactGA from 'react-ga';

export class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {

            status: false,
            email: '',
            IsFormSubmitted: false,

        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    async handleSubmit(event) {

        var formData = {

            "Email": this.state.email,

        };

        $.ajax({
            url: 'v1/api/user/subscribe',
            data: JSON.stringify(formData),
            dataType: 'json',
            contentType: "application/json; charset=utf-8",
            type: 'POST',

            success: (data) => {

                if (data.status) {

                    ReactGA.event({
                        category: 'Subscribe',
                        action: 'new Subscribtion added'
                    });

                    this.setState({
                        IsFormSubmitted: true,
                        status: true
                    }, function () {

                    });


                } else {

                }
            },

            error: (xhr, status, err) => {
                console.error(status, err.toString()); // eslint-disable-line
            },
        });


        event.preventDefault();
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }


    render() {

        //const showComfirm = !this.state.IsFormSubmitted;

        return (
            <>

              

               
                <section id="footer">
                    <div class="container">
                        <div class="row">
                            <div class="col-sm-12 text-center"><img src="images/killer_bg.png" class="" alt="" /></div>
                            <img src="img/9xm_logo.png" alt="" class="footer_img" />
                            <p class="copyright-text">For any queries : <a href="mailto:9xmmusicaltambola@9xmedia.in" >9xmmusicaltambola@9xmedia.in </a></p>
                            <p class="copyright-text">Copyright @ 2025. 9XM MUSICAL TAMBOLA. All Rights Reserved. </p>
                        </div>
                    </div>
                </section>

            </>
        );
    }
}
